import { LanguageSupportUtil } from './language_support_util';
import { ServerCommunicationUtil } from './server_communication_util';
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const getTrackActivity = track => {
  let activityName;
  if (track.activity) {
    activityName = track.activity.name; // map presenter
  } else if (track.activities && track.activities.length > 0) {
    activityName = track.activities[0]; // algolia format
  }
  if (!activityName) {
    return null;
  }
  // replaces spaces and dashes with underscores
  const activityKey = activityName.toUpperCase().replace(/(\s)|[-]/gi, '_');
  const localizedActivities = StringConstantsMixin.strings.FILTERS.ACTIVITIES;
  return localizedActivities[activityKey] ? localizedActivities[activityKey] : activityName;
};

const getTrackProfilePhotoUrl = (track, size = 'large', showStaticMap = true, staticMapSize = '396x180') => {
  if (track.profile_photo_url !== undefined) {
    return track.profile_photo_url;
  }
  if (track.ID === null || track.ID === 0) {
    return '';
  }
  const newPolylineColorsFlag = __AT_DATA__.experiments?.['web-feed-polyline-color']?.value === 'on';
  const apiUrl = newPolylineColorsFlag ? '/api/alltrails/v3' : '/api/alltrails';
  const staticMapOpts = showStaticMap ? `&show_static_map=yes&static_map_size=${staticMapSize}` : '';
  return `${apiUrl}/maps/${track.ID}/profile_photo?size=${size}&key=${ServerCommunicationUtil.apiKey}${staticMapOpts}`;
};

const getFormattedTrackUrls = (track, context) => {
  let trackUrl;
  if (track.slug) {
    trackUrl = `/explore/${track.type === 'map' ? 'map' : 'recording'}/${track.slug}`;
  } else {
    // If we dont have a slug for some reason go to explore
    trackUrl = `/explore`;
  }
  const languageRegionCode = context ? context.languageRegionCode : null;
  return {
    url: trackUrl,
    localizedUrl: LanguageSupportUtil.wrapUrlSafe(trackUrl, languageRegionCode)
  };
};

export { getTrackActivity, getTrackProfilePhotoUrl, getFormattedTrackUrls };
